import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AdminService } from '@app/features/admin/services/admin.service';

@Injectable({
  providedIn: 'root'
})
export class AdminNavigationService {
  private redirectChecked = false;      // stops multiple loops
  private lastResponse: any = null;     // cache API response
  private hasRedirectedToCustomers = false;

  constructor(private router: Router, private adminService: AdminService) { }

    checkAndRedirect(): Promise<string | null> {
        // If we’ve already handled redirect, don’t repeat
        if (this.redirectChecked) {
            return Promise.resolve(null);
        }

        //  Mark as checked to stop loops
        this.redirectChecked = true;

        //  Use cached response if available
        const apiCall = this.lastResponse ? Promise.resolve(this.lastResponse) : this.adminService.clientsPaymentMethod().toPromise();
        return apiCall
            .then((resp: any) => {
                this.lastResponse = resp;
                if (resp.contractView) {
                    return 'contractView';
                } else if (resp.invoicePaymentRequired) {
                    return 'invoicePaymentRequired';
                } else if (resp.ddRequired) {
                    return 'ddRequired';
                } else if (resp.ccRequired) {
                    return 'ccRequired';
                } else if (resp.achRequired) {
                    return 'achRequired';
                } 

                // condition: all flags false but isNewAdmin true

                const current = window.location.pathname;

                // If user is on either of these pages, DO NOT redirect to /customers
                if (
                    current === '/setup/payment_required/success' ||
                    current === '/setup/contract_summary/payment_method'
                ) {
                    return null;
                }
                
                if (
                    !resp.contractView &&
                    !resp.ddRequired &&
                    !resp.invoicePaymentRequired &&
                    !resp.ccRequired &&
                    !resp.achRequired &&
                    resp.isNewAdmin &&                     // new admin onboarding
                    !this.hasRedirectedToCustomers &&      // not redirected before
                    (current === '/' || current == '/setup/payment_required/invoice_list' || current == '/setup/contract_summary/payment_detail' || current == '/setup/show_smart_debit')      // not redirected befor) 
                ) {
                    this.hasRedirectedToCustomers = true;
                    window.location.replace('/customers');
                    return null;
                }
                return null;
            })
            .catch(() => null);
    }

}
